// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {use_theme} from '../../settings_ctx';
import {Default_banner, Form} from '../login/form';

export const use_login = (cp_after_login: boolean, cp_link: string)=>{
    const {show_modal} = use_theme();
    const show_login_form = (default_state?: string)=>{
        const login_props = {
            Banner: <Default_banner />,
            can_signup: true,
            next: cp_after_login ? cp_link || '/cp' : undefined,
            default_state: default_state || 'login_buttons',
            blocks: {
                social: {
                    hide_github: true,
                },
            },
        };
        show_modal('login_form', p=>{
            return <Form {...p}
              {...login_props}/>;
        }, {
          width: 736,
          paddingless: true,
          no_logo: true,
        });
    };

    const on_login = event=>{
        event.preventDefault();
        show_login_form();
    };
    const on_signup = event=>{
        event.preventDefault();
        show_login_form('signup_buttons');
    };
    return {
        on_login, on_signup, show_login_form,
    };
};
